import { ManagementFlatDTO } from "../domain/models/dto/ManagementDTO";
import { IManagementFlat } from "../domain/models/Management";
import { ManagementFlatModel } from "../models/ManagementFlatModel";
import { FileMapper } from "./FileMapper";
import { SimpleMapper } from "./SimpleMapper";

export class ManagementFlatMapper extends SimpleMapper<
    IManagementFlat,
    ManagementFlatDTO
> {
    protected toDTOFields: string[] = [
        "id",
        "fullName",
        "position",
        "isActive",
        "languageCode",
        "files",
    ];
    protected fromDTOFields: string[] = [
        ...this.toDTOFields,
        "updatedAt",
        "createdAt",
        "creatorId",
    ];
    protected entityConstructor = ManagementFlatModel;

    private fileMapper = new FileMapper();

    fromDTO(dto: ManagementFlatDTO): IManagementFlat {
        if (!dto) return null;

        const baseDto = super.fromDTO(dto);
        baseDto.files =
            dto.files?.map((file) => this.fileMapper.fromDTO(file)) ?? [];

        return baseDto;
    }

    toDTO(model: IManagementFlat): ManagementFlatDTO {
        if (!model) return null;

        const baseDto = super.toDTO(model);
        baseDto.files =
            model.files?.map((file) => this.fileMapper.toDTO(file)) ?? [];

        return baseDto;
    }
}
